import { Project } from "../model/project";
import { SecuritySystem } from "../model/security-system";

export class ProjectHelperService {
    static getProjectUuid(project: Project) {
        return project?.claresystem?.uuid || project?.uuid || "";
    }

    static getDbSecuritySystem(project: Project) {
        return project.securitysystem || new SecuritySystem(null);
    }

    static getDbSecuritySystemMacAddress(project: Project) {
        return project && project.securitysystem ? project.securitysystem.macAddress || "" : "";
    }

    static isClareOne(uuid: string) {
        return uuid?.startsWith("58:67:7F:93") || uuid?.startsWith("58:67:7F:94");
    }
}
